import {http} from "./httpClient";

export const createVipuskForDemand = (data) =>
	http.post("gotoviy", "/vipusks", {
		data: {
			furniture_id: data.furnitureId,
			unique_id: data.uniqueId,
			demand_furniture_id: data.demandFurnitureId,
			amount: data.amount,
			package_quantity: data.package_quantity,
			glass_quantity: data.glass_quantity,
			glass_wood_quantity: data.glass_wood_quantity,
			lxdf_quantity: data.lxdf_quantity,
			status: true,
		},
	});

export const createVipuskForSupermarket = (data) =>
	http.post("gotoviy", "/vipusks/supermarket", {
		data: {
			tree_id: data.treeId,
			color_id: data.colorId,
			position_id: data.positionId,
			furniture_id: data.furnitureId,
			amount: data.amount,
			package_quantity: data.package_quantity,
			glass_quantity: data.glass_quantity,
			glass_wood_quantity: data.glass_wood_quantity,
			lxdf_quantity: data.lxdf_quantity,
		},
	});
